
import {Component, Vue} from 'vue-property-decorator';
import HomeAds4 from "@/views/HomeAds4.vue";
import {destroyGanalytics, installGanalytics, trackEvent} from "@/components/Tracker";

@Component({
  components: {HomeAds4}
})
export default class Home4 extends Vue {
  public mounted() {
    // Google Vignette locks page scrolling while the interstitial is up. When it is
    // dismissed the hash flips back to the anchor the user originally clicked and
    // hashchange fires immediately, but Google tears down the scroll lock a few frames
    // later, and that teardown resets scrollY to 0. So a single scrollIntoView() here
    // is undone right after it happens. Instead we hold the target position for a
    // short while, re-applying it whenever something moves us away from it.
    let cancelGuard: (() => void) | null = null;

    const scrollToAnchor = (el: HTMLElement) => {
      if (cancelGuard) {
        cancelGuard();
      }
      const deadline = Date.now() + 1500;
      let expectedY = -1;
      let cancelled = false;

      // Any real scrolling gesture means the user has taken over; stop fighting them.
      const onUserGesture = () => { cancelled = true; };
      const events = ["wheel", "touchstart", "keydown", "pointerdown"];
      events.forEach(e => window.addEventListener(e, onUserGesture, {passive: true}));
      cancelGuard = () => {
        cancelled = true;
        events.forEach(e => window.removeEventListener(e, onUserGesture));
        cancelGuard = null;
      };

      const tick = () => {
        if (cancelled) {
          return;
        }
        if (window.scrollY !== expectedY) {
          // Either our first scroll, or the vignette teardown moved us. Re-assert,
          // recomputing from the element so we survive layout shifts too.
          el.scrollIntoView();
          expectedY = window.scrollY;
        }
        if (Date.now() < deadline) {
          requestAnimationFrame(tick);
        } else if (cancelGuard) {
          cancelGuard();
        }
      };
      tick();
    };

    window.onhashchange = () => {
      const id = location.hash.startsWith("#") ? location.hash.substring(1) : "top";
      if (id === "google_vignette") {
        // The interstitial just opened. Leave the page alone; we get another
        // hashchange with the real anchor once the user closes it.
        return;
      }
      const el = document.getElementById(id);
      if (el) {
        scrollToAnchor(el);
      }
    };
    installGanalytics();
    trackEvent("landing-v4");
  }

  public beforeDestroy() {
    destroyGanalytics();
  }
}
